import * as LocationActions from "../actions/LocationActions";
import axios from 'axios';

export function getByGeometry(geometry) {

	const headers = new Headers();
    headers.set('Accept', 'application/json');

    const data = new URLSearchParams();
    data.set('scController', 'LocationFinder');
    data.set('scAction', 'FindLocations');
    data.set('lat', geometry.lat().toString());
    data.set('lon', geometry.lng().toString());
    data.set('maxDistance', 50);

    axios({
        method: 'POST',
        url: window.location.href,
        headers,
        data
    })
    .then((response) => LocationActions.receiveByGeometry(response.data))
    .catch(function(error) {
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        }
    });
}